<template>
	<div>
		<div style="height: 300px">
			<canvas :id="'chart-' + id"></canvas>
		</div>
	</div>
</template>

<script>
	import Chart from 'chart.js/auto'

	import uniqueId from "lodash.uniqueid";

	export default {
		props: ["chartData"],
		data() {
			return {
				id: uniqueId("")
			}
		},
		mounted() {
			// this.chartData is created in the mixin.
			// If you want to pass options please create a local options object
			this.options = {
				scales: {
					y: {
						beginAtZero: true
					}
				},
    			responsive: true,
				maintainAspectRatio: false,
			};

			console.log()

			var ctx = document.getElementById('chart-' + this.id);
			new Chart(ctx, {
				type: 'line',
				data: this.chartData,
				options: this.options
			});
		},
	};
</script>